import React, {useState, useCallback} from 'react';
import {setAnnotationDragging} from 'actions/index.js';
import { connect } from "react-redux";
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

function AnnotationComponent({attributes, annotation, color, onDelete, setAnnotationDragging}) {
    const [text, setText] = useState(annotation.text);

    const onChange= useCallback((event) => {
        event.stopPropagation();
        annotation.text = event.target.value;
        setText(event.target.value);
    }, [setText]);

    let style = {
        left: annotation.x,
        top: annotation.y,
        backgroundColor: color
    };

    let textStyle ={
        backgroundColor: color,
    };

    if (attributes && attributes["secondary-color"]) {
        textStyle.color =  attributes["secondary-color"];;
    }

    const onMouseDown = useCallback((e) => {
        setAnnotationDragging(annotation);
    }, [setAnnotationDragging]);

    return (
        <div style={style} className="annotation">
          <div
            onMouseDown={onMouseDown}
            className="draggable-header">
            <div className="delete-button" onClick={onDelete}>x</div>
          </div>
          <textarea
            style={textStyle}
            onChange={onChange}
            type="textarea"
            value={text}
            placeholder="Write a note" className="annotation-text"/>
        </div>
    );
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setAnnotationDragging: a => dispatch(setAnnotationDragging(a)),
    };
}

export default connect(null, mapDispatchToProps)(AnnotationComponent);
 
